import React, { useState } from "react";
import Star from "../../Stars/Star";
import "./FormA.css";

const Formcomponent = ({ jsonarray, clientratings }) => {
  // const [rowcount, setRowcount] = useState(1);
  const [starvalues, setStarvalues] = useState([]);
  const [managerRating, setManagerRating] = useState(0);
  const [clientRating, setClientRating] = useState(0);

  let tableHeader_cells = {
    colm_1:
      "Tasks could be deduced from respective JDs towards accomplishing corporate & business objectives",
    colm_2:
      "Appraiser should highlight staff accomplishment towards meeting the objectives during period of appraisal. List the tasks on JD, comment on each and give example.",
    colm_3: "(1,2,3,4)",
    colm_4: "(1,2,3,4)",
  };

  const handleSeleted = (newValue, index) => {
    let varyArray;
    setStarvalues((prevArray) => {
      const newArray = [...prevArray]; // Create a copy of the original array
      newArray[index] = newValue; // Update the value at the specified index
      varyArray = newArray;
      return newArray; // Set the state with the updated array
    });
    setClientRating(
      varyArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      )
    );

    clientratings ({
      socreobtained: varyArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      ),
      scoreobtainable: jsonarray.kpis.length * 4
    })
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // setExperbuild({ ...experbuild, [name]: value });
  };

  return (

    <div className="w-full">
      <table>
        <thead>
          <tr className="bg-[#C4BC96]">
            <th
              scope="col"
              className="text-center w-full justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Task</b> <br />
              {tableHeader_cells.colm_1}
            </th>

            <th
              scope="col"
              className="text-center w-full justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Accomplishment</b> <br />
              {tableHeader_cells.colm_2}
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[100px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Staff Ratings</b> <br />
              {tableHeader_cells.colm_3}
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[100px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>Manager’s Ratings</b> <br />
              {tableHeader_cells.colm_4}
            </th>
          </tr>
        </thead>
        <tbody>

          {jsonarray.kpis?.map((items, index) => {
            return (
              <tr>
                <td data-label={tableHeader_cells.colm_1}>
                  {" "}
                  <textarea
                    name="CriticalExperience"
                    onChange={handleChange}
                    type="text"
                    className="w-full outline-none "
                    placeholder="Insert Need"
                    value={items.task}
                  />{" "}
                </td>
                <td data-label={tableHeader_cells.colm_2}>
                  {" "}
                  <textarea
                    name="CriticalExperience"
                    onChange={handleChange}
                    type="text"
                    className="w-full outline-none "
                    placeholder="Insert Need"
                    value={items.accomplishment}
                  />{" "}
                </td>
                <td data-label={tableHeader_cells.colm_3}>
                  <Star
                    currentrating={items.staff_rating}
                    selectedstar={(e) => handleSeleted(e, index)}
                    status={false}
                  />
                </td>
                <td data-label={tableHeader_cells.colm_4}>
                  <Star
                    currentrating={items.supervisor_rating}
                    selectedstar={(e) => handleSeleted(e, index)}
                    status={true}
                  />
                </td>
              </tr>
            );
          })}

          <tr>
            <td data-label={tableHeader_cells.colm_1}>
              {" "}
              <b>Total</b>{" "}
            </td>
            <td data-label={tableHeader_cells.colm_2}> </td>
            <td data-label={tableHeader_cells.colm_3}> {clientRating} </td>
            <td data-label={tableHeader_cells.colm_4}> {managerRating} </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Formcomponent;
